import { Injectable, inject } from "@angular/core";

import { OrderActivityService } from "../../services/order-activity.service";

@Injectable({providedIn: 'root'})
export class CanDeactivateOrderActivityGuard {
    private orderActivityService = inject(OrderActivityService);


    //reset the OrderActivityComponent when we navigate away from vendor/order-activity
    canDeactivate() {
        this.orderActivityService.resetState();
        return true;
    }
}